import createActionByConditionFactory from '@Utils/Redux/actionByConditionFactory';
import { showGlobalSpinner, hideGlobalSpinner } from '@Containers/GlobalSpinner/GlobalSpinnerActions';

export function beforeAction(dispatch) {
  dispatch(showGlobalSpinner());
}

export function afterAction(dispatch) {
  dispatch(hideGlobalSpinner());
}

export function onError(dispatch) {
  dispatch(hideGlobalSpinner());
}

export const withGlobalSpinnerActionEnhancer = createActionByConditionFactory({
  beforeAction,
  afterAction,
  onError,
});
